import { useState, useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const EXPAND_2_TOWER_RECS_TEST_NAME = 'HP_Expand2TowerRecs_Aug2026';

export const trackExpand2TowerRecsTest = (): void => {
    trackAbTestV2Variant(EXPAND_2_TOWER_RECS_TEST_NAME);
};

const isExpand2TowerRecsTestVariant = (): boolean =>
    getAbTestV2(EXPAND_2_TOWER_RECS_TEST_NAME)?.variant === 'variant';

export const useIsExpand2TowerRecsTestVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(isExpand2TowerRecsTestVariant());
    }, []);

    return isVariant;
};
